<template>
  <b-col md="4">
    <b-card class="mb-2">
      <b-tabs>
        <b-tab
          id="tab-right-1"
          title="ดำเนินการ"
        >
          <b-tabs class="p-1">
            <b-tab
              id="tab-right-3"
              title="ดำเนินการ"
            >
              <b-row>
                <b-col
                  v-for="(box, index) in optionContinue"
                  :key="index"
                  cols="12"
                  class="mt-1"
                >
                  <b-form-radio
                    :key="index"
                    v-model="selectSend"
                    :value="box.value"
                  >
                    {{ box.text }}
                  </b-form-radio>
                  <b-col
                    cols="12"
                    class="pl-2"
                  >
                    <b-form-select
                      v-model="box.selectedOption"
                      :options="box.selectOptions"
                      class="mt-1 pl-1"
                    />
                  </b-col>
                </b-col>

                <b-col cols="12 mt-2">
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                    />
                  </b-form-group>

                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex justify-content-between mt-2"
                >
                  <b-button
                    variant="secondary"
                    @click="onBackBtnClicked"
                  >
                    ยกเลิก
                  </b-button>

                  <b-button
                    variant="primary"
                    @click="onSubmitBtnCliked"
                  >
                    บันทึก
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              id="tab-right-4"
              title="ส่งต่อ"
            >
              <b-row>
                <b-col
                  v-for="(box, index) in optionSend"
                  :key="index"
                  cols="12"
                  class="mt-1"
                >
                  <b-form-radio
                    :key="index"
                    v-model="selected"
                    :value="box.value"
                  >
                    {{ box.text }}
                  </b-form-radio>
                  <b-col
                    v-if="index === 0"
                    cols="12"
                    class="pl-2"
                  >
                    <b-form-select
                      v-model="selectedGroup"
                      :options="selectGroup"
                      class="mt-1"
                    />
                  </b-col>
                </b-col>
                <b-col cols="12 mt-2">
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                    />
                  </b-form-group>

                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex justify-content-between mt-2"
                >
                  <b-button
                    variant="secondary"
                    @click="onBackBtnClicked"
                  >
                    ยกเลิก
                  </b-button>

                  <b-button
                    variant="primary"
                    @click="onSubmitBtnCliked"
                  >
                    บันทึก
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              id="tab-right-5"
              title="อื่นๆ"
            />
          </b-tabs>
        </b-tab>
        <b-tab
          id="tab-right-2"
          title="ประวัติ"
        />
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormRadioGroup,
  BFormSelect,
  BFormFile,
  BButton,
  BFormRadio,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
    BFormRadio,
  },
  data() {
    return {
      optionContinue: [
        {
          text: 'ชั้นดำเนินการ',
          value: 1,
          selectOptions: [
            {
              text: 'หน่วยงาน',
              value: null,
            },
            {
              text: 'หน่วยงาน1',
              value: 1,
            },
          ],
          selectedOption: null,
        },
        {
          text: 'สถานะ',
          value: 2,
          selectOptions: [
            {
              text: 'TEXT1',
              value: null,
            },
            {
              text: 'TEXT2',
              value: 1,
            },
          ],
          selectedOption: null,
        },
      ],
      optionSend: [
        { text: 'ส่งเรื่องเข้ากลุ่มดำเนินการ', value: 1 },
        { text: 'คัดลอกเป็นเรื่องใหม่', value: 2 },
      ],
      selectGroup: [
        { text: 'กลุ่ม1', value: null },
        { text: 'กลุ่ม2', value: 1 },
        { text: 'กลุ่ม3', value: 2 },
      ],
      selected: 1,
      selectSend: 1,
      selectedGroup: null,
    }
  },
  methods: {
    onSubmitBtnCliked() {
      console.log('selected', this.selected)
      console.log('selectSend', this.selectSend)
    },
    onBackBtnClicked() {
      const routeData = this.$router.resolve({ name: 'provoff' })
      window.open(routeData.href, '_self')
    },
  },
}
</script>

<style></style>
